<div class="stories-wrapper">
  <div class="card-container">
    <div class="heading text-center">Our Success Stories</div>
    <div class="hr-yellow"></div>
    <div class="slider-wrapper">
      <ngx-glide [showArrows]="false" [showBullets]="true" [bound]="true" [dragThreshold]="false" [breakpoints]="breakpoints">
        <div class="card" *ngFor="let desc of getdescriptions">
          <div class="flex">
            <div class="img-wrapper">
              <img loading="lazy" data-src="{{desc.image}}" />
            </div>
            <div>
              <div class="name">{{desc.name}}</div>
              <div class="raised" [innerHTML] ="desc.raised | safeHtml"></div>
              <div class="descr">{{desc.descriptn}}</div>
            </div>
          </div>
        </div>
      </ngx-glide>
    </div>
  </div>
</div>
